import VeeValidate from 'vee-validate';
export default {
    phoneOrEmail: {
        getMessage: field => 'Только русские и казахские символы 2',
        validate: value => {

          let emailConfirm = VeeValidate.Rules.email(value);
          let phoneConfirm = VeeValidate.Rules.min(value.trim().replace(/[^0-9.]/g, ""), [11]) && VeeValidate.Rules.max(value.trim().replace(/[^0-9.]/g, ""), [11]);

          return  emailConfirm || phoneConfirm;
        },
    }
};
